import { nullableSchema, objectSchema } from "vue-utils"
import type { Nullable } from "../IncidentEntity"
import { UnitLength } from "../UnitLength"

export interface ShipDescription {
	length: Nullable<UnitLength>

	/** Text description of the ship's hull colour (if known) */
	hullColour: Nullable<string>

	/** Text description of the colour of the super structure (if known) */
	superstructureColour: Nullable<string>

	/** Text description of the colour of the sail (if applicable & known) */
	sailColour: Nullable<string>

	additionalInformation: string
}

export const ShipDescription = objectSchema<ShipDescription>({
	length: nullableSchema(UnitLength),
	hullColour: nullableSchema(String),
	superstructureColour: nullableSchema(String),
	sailColour: nullableSchema(String),
	additionalInformation: String,
})
